/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';

import IconButton from 'material-ui/IconButton';
import ArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import ArrowUp from 'material-ui/svg-icons/hardware/keyboard-arrow-up';

import './CollapseCustomizable.scss';

export default function CollapseCustomizable({
    head,
    body = null,
    _key,
    headStyle = {},
    bodyStyle = {},
    withCollapseIcon = true,
}) {
    const [isCollapsed, setIsCollapsed] = useState(true);

    const collapse = (e) => {
        if (e.target.tagName.toLowerCase() !== 'input') {
            setIsCollapsed(!isCollapsed);
        }
    };

    return (
        <div className='collapse-customizable' key={_key}>
            <div 
                className='collapse-customizable-head'
                style={headStyle}
                onClick={collapse}
            >
                { head }
                { withCollapseIcon ?
                    <IconButton 
                        className='collapse-customizable-arrow'
                    >
                        { isCollapsed ?
                            <ArrowDown color='#B2B2B2' /> :
                            <ArrowUp color='#B2B2B2' />
                        }
                    </IconButton> :
                    null
                }
            </div>
            { body ? 
                <div 
                    className='collapse-customizable-body'
                    style={{
                        ...bodyStyle,
                        maxHeight: isCollapsed ? '0px' : 'unset',
                        overflow: 'hidden',
                    }}
                >
                    { body }
                </div> :
                null
            }
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/common/CollapseCustomizable.jsx